/*
function getStackTrace() {
    // maybe use stacktrace-js instead? 37kb though
    let stack;
    try {
        throw new Error("");
    }
    catch (error) {
        stack = error.stack || "";
    }

    stack = stack.split("\n").map(line => { return line.trim(); });
    return stack.splice(stack[0] === "Error" ? 2 : 1);
}
class Tracer extends Transform {
    format(entry) {
        getStackTrace();
        entry.args;
        entry.char; // line-char
        entry.line; // line
        entry.date; // iso-date (string)
        entry.file;
        entry.levelNumber; // log level
        entry.method; // function-name calling log
        return entry;
    }
}
*/

// eslint-disable-next-line max-statements
export default () => {
    const globalContext = self || window || global || this;
    if (!globalContext.console) {
        throw new Error("Couldn't find loggin context!");
    }
    return globalContext.console;
    /*
    // eslint-disable-next-line no-empty-function
    const startSpan = () => {}; // no-op for now, replace with tracingSpan start
    // eslint-disable-next-line no-empty-function
    const endSpan = () => {}; // no-op for now, replace with tracingSpan stop

    const { group } = console, { groupCollapsed } = console, { groupEnd } = console;
    console.warn = (...args) => {
        logger.log(...args);
    };
    console.info = (...args) => {
        logger.log("info", ...args);
    };
    console.debug = (...args) => {
        logger.log("debug", ...args);
    };
    console.error = (...args) => {
        logger.log("error", ...args);
    };
    console.emergency = (...args) => {
        logger.log("emergency", ...args);
    };
    console.emerg = (...args) => {
        logger.log("emergency", ...args);
    };
    console.alert = (...args) => {
        logger.log("alert", ...args);
    };
    console.critical = (...args) => {
        logger.log("critical", ...args);
    };
    console.crit = (...args) => {
        logger.log("crit", ...args);
    };
    console.err = (...args) => {
        logger.log("err", ...args);
    };
    console.warning = (...args) => {
        logger.log("warning", ...args);
    };
    console.note = (...args) => {
        logger.log("note", ...args);
    };
    console.default = (...args) => {
        logger.log("default", ...args);
    };
    console.notice = (...args) => {
        logger.log("notice", ...args);
    };
    console.group = (...args) => {
        startSpan(...args);
        group(...args);
    };
    console.groupCollapsed = (...args) => {
        startSpan(...args);
        groupCollapsed(...args);
    };
    console.groupEnd = (...args) => {
        endSpan(...args);
        groupEnd(...args);
    };

    return globalContext.console;
    */
};
